import React from 'react';

// Универсальный враппер поля формы: label + input/select/textarea
export default function FormField({ label, error, children, required }) {
  return (
    <div style={{ marginBottom: 16 }}>
      {label && (
        <label style={{
          display: 'block',
          fontSize: 'var(--text-sm)',
          fontWeight: 'var(--font-medium)',
          color: 'var(--text-secondary)',
          marginBottom: 6,
        }}>
          {label}{required && <span style={{ color: 'var(--accent)', marginLeft: 2 }}>*</span>}
        </label>
      )}
      {children}
      {error && (
        <p style={{ margin: '4px 0 0', fontSize: 'var(--text-xs)', color: 'var(--status-error)' }}>
          {error}
        </p>
      )}
    </div>
  );
}

export const inputCss = {
  width: '100%',
  padding: '9px 12px',
  fontSize: 'var(--text-sm)',
  fontFamily: 'var(--font-family)',
  border: '1px solid var(--border)',
  borderRadius: 'var(--radius-md)',
  outline: 'none',
  boxSizing: 'border-box',
  color: 'var(--text-primary)',
  background: 'var(--bg-base)',
};
